import React from "react";
import { Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSetAtom } from "jotai";

import "./TransactionsEmptyState.scss";
import PosWithWebIcon from "../../icons/PosWithWebIcon";
import { HandleTopup } from "../../topup/TopupFlow/types";
import {
  initiateTopupTriggerAtom,
  InitiateTopupTriggers,
} from "../../../jotai/atoms/analytics";

export default function TransactionsEmptyState({
  handleTopup,
  isFiat,
}: {
  handleTopup: HandleTopup;
  isFiat: boolean;
}) {
  const { t } = useTranslation("wallet");
  const setInitiateTopupTrigger = useSetAtom(initiateTopupTriggerAtom);
  const goToTopup = () => {
    setInitiateTopupTrigger(InitiateTopupTriggers.TRANSACTIONS_EMPTY_STATE);
    handleTopup();
  };

  return (
    <div className="TransactionsEmptyState">
      <PosWithWebIcon />
      <Stack gap={2} className="TextDescription">
        <p className="fw-bold Grotesk Copy">{t("no_transactions_yet")}</p>
        <p className="Grotesk SpecialFontSettings SubCopy">
          {t("you_have_not_initiated_any_transactions_yet")}
          {t("common:punctuations.full_stop")}
        </p>
      </Stack>
      <button className="SpecialFontSettings TopupHpr" onClick={goToTopup}>
        {isFiat ? t("top_up") : `${t("top_up")} HPR`}
      </button>
    </div>
  );
}
